﻿import {gsap} from "gsap";
import {EntityView} from "./EntityView";
import {Random} from "../../Utils/Unity/Random";
import {GameManager} from "../GameManager";
import {Core} from "../../Base/Core";

export class BubbleView extends EntityView {

    Awake() {
        super.Awake();
        this.pivot.y = 1000;
        this.sprite.setImage("creatures/bubble");
    }

    mouseDown() {
        this.spawnParticles();
        Core.Vibro.Vibrate();
        GameManager.gameController.AddCreatureFromBubble(this.position);
        this.emit("Opened");
        this.RemoveView();
        Core.Audio.Play("BubbleOpen");

        if (Core.Player.PlanetsSave.TutorSave.bubbles < 2) {
            Core.Player.PlanetsSave.TutorSave.bubbles++;
        }
    }

    spawnParticles() {
        // TODO
    }

    SpawnTo(position) {
        let animate = (GameManager.gameView.selectedEpochId == Core.Player.PlanetsSave.CurrentPlanet.StartEpoch);
        this.position.copyFrom(position);
        if (animate) {
            this.pivot.y = Core.app.viewport.height;
            let animation = gsap.timeline();
            animation
                .to(this.pivot, {y: 0, duration: 0.5, ease: "power3.in"}, "+=" + Random.Range(0, 0.5))
                .to(this.sprite.scale, {y: 0.7, duration: 0.2, ease: "power3.in"}, "-=0.3")
                .to(this.sprite.scale, {y: 1, duration: 0.7, ease: "elastic.out"}, "+=0")
                .eventCallback("onComplete", () => {
                    this.Idle();
                })
            ;
        }
        else {
            this.pivot.y = 0;
        }
    }

    Idle() {
        this._idleAnimation = gsap.timeline()
            .repeat(-1)
            .to(this.sprite.scale, {x: 1.05, y: 0.9, duration: 1, ease: "power1.out"}, "+=0")
            .to(this.sprite.scale, {x: 1, y: 1, duration: 1, ease: "power1.in"}, "+=0")
        ;
    }

    Update() {
        super.Update();
    }

    RemoveView() {
        if (this._idleAnimation) {
            this._idleAnimation.kill();
        }
        GameManager.gameView.RemoveBubbleView(this);
    }
}
